import React from "react";

import { Navigate, Link, useLocation } from "react-router-dom";

import { UseAuth } from "../hooks/useAuth";
const passurl='/new-password';


export default function LayoutDefault(props) {
  const { children } = props;
  const { user, isLoading } = UseAuth();
  const location = useLocation();
  
 
   if (!user && !isLoading) {
    return <Navigate to ="/sign-in" replace />;
  }

  console.log(location);
  if (user.MUST_CHANGE_PASSWORD === 1 && location.pathname !== passurl) {
    return <Navigate to = {passurl} replace />;
   }
 

  return (
    <div>
      {/* {TODO: navbar} */}
    <div >{children}</div>
      {/* {TODO: coppyright} */}
    </div>
  );
}